var map = {
	"./feedback_type.json": "9ebe",
	"./genders.json": "5756",
	"./project_status.json": "f5ca",
	"./project_type.json": "0ec3",
	"./system_languages.json": "4695",
	"./system_themes.json": "8738",
	"./task_priority.json": "42fa",
	"./task_status.json": "a09f",
	"./user_roles.json": "62e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f78d";